/**
 * Public barrel export for the SharePill molecule (SE-5527).
 * @module components/molecules/SharePill
 */
export { default } from "./SharePillContainer";
export type { SharePillProps } from "./SharePillContainer";
